export const routinedata = [
    [{
        bodyPart: "chest",
        equipment: "barbell",
        gifUrl: "http://d205bpvrqc9yn1.cloudfront.net/0025.gif",
        id: "0025",
        name: "barbell bench press",
        target: "Full Chest",
    }, {
        bodyPart: 'chest', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0314.gif', id: '0314', name: 'dumbbell incline bench press', target: "Upper Chest"
    }, {
        bodyPart: 'chest', equipment: 'cable', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0188.gif', id: '0188', name: 'cable middle fly', target: "Mid Chest"
    }, {
        bodyPart: 'chest', equipment: 'leverage machine', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0596.gif', id: '0596', name: 'lever seated fly', target: "Mid Chest"
    }, {
        bodyPart: 'shoulders', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0290.gif', id: '0290', name: 'dumbbell bench seated press', target: "Front delts"
    }, {
        bodyPart: 'upper arms', equipment: 'cable', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0241.gif', id: '0241', name: 'cable triceps pushdown (v-bar)', target: "Triceps"
    }, {
        bodyPart: 'upper arms', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0330.gif', id: '0330', name: 'dumbbell incline triceps extension', target: "Triceps"
    }
    ],
    [{
        bodyPart: 'back', equipment: 'cable', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0198.gif', id: '0198', name: 'cable pulldown', target: "Lats"
    }, {
        bodyPart: 'back', equipment: 'cable', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0239.gif', id: '0239', name: 'cable straight back seated row', target: "Upper Back"
    }, {
        bodyPart: 'back', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0027.gif', id: '0027', name: 'barbell bent over row', target: "Upper Back"
    }, {
        bodyPart: 'back', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0095.gif', id: '0095', name: 'barbell shrug', target: "Traps",
    }, {
        bodyPart: 'shoulders', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0334.gif', id: '0334', name: 'dumbbell lateral raise', target: "Side Delts"
    }, {
        bodyPart: 'upper arms', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0298.gif', id: '0298', name: 'dumbbell cross body hammer curl', target: "Biceps",
    }, {
        bodyPart: 'upper arms', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0080.gif', id: '0080', name: 'barbell reverse curl', target: "Biceps",
    }
    ],
    [{
        bodyPart: 'upper legs', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0043.gif', id: '0043', name: 'barbell full squat', target: 'Glutes'
    }, {
        bodyPart: 'upper legs', equipment: 'sled machine', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/1463.gif', id: '1463', name: 'sled 45в° leg press (side pov)', target: 'Quads'
    }, {
        bodyPart: 'upper legs', equipment: 'leverage machine', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0585.gif', id: '0585', name: 'lever leg extension', target: 'Quads',
    }, {
        bodyPart: 'upper legs', equipment: 'leverage machine', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0586.gif', id: '0586', name: 'lever lying leg curl', target: 'Hamstrings'
    }, {
        bodyPart: 'lower legs', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0088.gif', id: '0088', name: 'barbell seated calf raise', target: 'Calves',
    }, {
        bodyPart: 'lower legs', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0108.gif', id: '0108', name: 'barbell standing leg calf raise', target: 'Calves'
    }],
    [],
    [{
        bodyPart: 'shoulders', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0290.gif', id: '0290', name: 'dumbbell bench seated press', target: 'Delts'
    }, {
        bodyPart: 'shoulders', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0120.gif', id: '0120', name: 'barbell upright row', target: 'Delts'
    }, {
        bodyPart: 'shoulders', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0310.gif', id: '0310', name: 'dumbbell front raise', target: 'Front Delts'
    }, {
        bodyPart: 'shoulders', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0334.gif', id: '0334', name: 'dumbbell lateral raise', target: 'Side Delts'
    }, {
        bodyPart: 'shoulders', equipment: 'cable', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0233.gif', id: '0233', name: 'cable standing rear delt row (with rope)', target: 'Rear Delts'
    }, {
        bodyPart: 'back', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0406.gif', id: '0406', name: 'dumbbell shrug', target: 'Traps'
    }],
    [{
        bodyPart: 'upper arms', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0031.gif', id: '0031', name: 'barbell curl', target: 'Biceps',
    }, {
        bodyPart: 'upper arms', equipment: 'barbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0060.gif', id: '0060', name: 'barbell lying triceps extension skull crusher', target: 'Triceps',
    }, {
        bodyPart: 'upper arms', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/1647.gif', id: '1647', name: 'dumbbell alternate preacher curl',
    }, {
        bodyPart: 'upper arms', equipment: 'cable', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0201.gif', id: '0201', name: 'cable pushdown', target: 'Triceps'
    }, {
        bodyPart: 'upper arms', equipment: 'dumbbell', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0315.gif', id: '0315', name: 'dumbbell incline biceps curl', target: 'Biceps'
    }, {
        bodyPart: 'upper arms', equipment: 'body weight', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/0814.gif', id: '0814', name: 'triceps dip', target: 'Triceps'
    }],
    [{
        bodyPart: 'cardio', equipment: 'leverage machine', gifUrl: 'http://d205bpvrqc9yn1.cloudfront.net/3666.gif', id: '3666', name: 'walking on incline treadmill', target: 'Cardiovascular System'
    }]
]